import Request, { RequestUpdateBody } from "app/models/request"
import { AxiosPromise } from "axios"
import { planningApi } from "./api"

export const patchRequests = (requestUpdates: RequestUpdateBody[]): AxiosPromise =>
  planningApi("/hr_unavailabilities", {
    data: requestUpdates.map(absence => ({
      id: absence._id,
      date: absence.date,
      employee_id: absence.uid,
      hr_code_id: absence.code?.id,
      start_time: absence.from,
      end_time: absence.to,
      status: absence.status,
    })),
    method: "PATCH",
  })

export const postRequest = (payload: Request[]): AxiosPromise =>
  planningApi("/hr_unavailabilities", {
    data: payload.map(absence => ({
      date: absence.date,
      employee_id: absence.uid,
      hr_code_id: absence.code?.id,
      start_time: absence.from,
      end_time: absence.to,
    })),
    method: "POST",
  })
